import React from 'react';

import AppRoutes from './layout';

const AppRoutesContainer = () => <AppRoutes />;

export default AppRoutesContainer;
